import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '@client/toolkit';

import { RowStackContext } from './row-stack-context';

export interface EconomyCardProps {
  title: string;
  className?: string;
  /** Stack children as label/value rows with a consistent vertical rhythm. */
  rowStack?: boolean;
  /** Header controls, e.g. the Rediger / Avbryt+Lagre pair on an editable section. */
  actions?: ReactNode;
}

/** Section card. Surface, border and radius all come from the toolkit `Card`. */
export function EconomyCard({
  title,
  className,
  rowStack = false,
  actions,
  children,
}: PropsWithChildren<EconomyCardProps>) {
  return (
    <Card className={className}>
      {/* pb-6 rather than the header's default pb-4: 24px below the heading is what the
          other title-only cards sit at (the Aktører list card is the closest match). */}
      <CardHeader className="pb-6">
        <CardTitle className="flex-1" variant="highlighted">
          {title}
        </CardTitle>
        {actions}
      </CardHeader>
      {/* One grid for the whole stack, not one per row, so every label lines up. Three
          equal columns across the full card: the label takes one, the value the other
          two. Requested proportion — a short label therefore leaves a wide gap before
          its value. Tables keep the full width and their own columns. */}
      {/* The rows read this to know whether there is a card grid for them to join. */}
      <RowStackContext.Provider value={rowStack}>
        <CardContent className={classNames(rowStack && 'grid grid-cols-1 gap-x-4 gap-y-3 sm:grid-cols-3')}>
          {children}
        </CardContent>
      </RowStackContext.Provider>
    </Card>
  );
}

export default EconomyCard;
